<!-- Return Settings Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h4 class="popup-title">
        <span class="popup-title-icon">
          <i class="fas fa-cog"></i>
        </span>
        Gestione Tipi di Reso
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Tabs -->
    <div class="popup-tabs">
      <button type="button" class="tab-btn"
              [class.active]="activeTab === 'list'"
              (click)="setActiveTab('list')">
        <i class="fas fa-list me-2"></i> Lista
      </button>
      <button type="button" class="tab-btn"
              [class.active]="activeTab === 'new'"
              (click)="setActiveTab('new')">
        <i class="fas fa-plus me-2"></i> Nuovo
      </button>
      <button type="button" class="tab-btn"
              [class.active]="activeTab === 'edit'"
              [disabled]="!selected"
              (click)="setActiveTab('edit')">
        <i class="fas fa-edit me-2"></i> Modifica
      </button>
    </div>

    <div class="popup-body">

      <!-- Alerts -->
      <div *ngIf="errorMessage" class="alert alert-danger py-2">
        <i class="fas fa-exclamation-circle me-2"></i>{{ errorMessage }}
      </div>
      <div *ngIf="successMessage" class="alert alert-success py-2">
        <i class="fas fa-check-circle me-2"></i>{{ successMessage }}
      </div>

      <!-- ===== TAB: LISTA ===== -->
      <div class="tab-content" *ngIf="activeTab === 'list'">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="input-icon-wrapper" style="max-width: 320px; flex: 1;">
            <i class="input-icon fas fa-search"></i>
            <input type="text" class="form-control"
                   placeholder="Cerca..."
                   [(ngModel)]="searchTerm">
          </div>
        </div>

        <div *ngIf="loading" class="text-center text-muted py-4">
          <i class="fas fa-spinner fa-spin fa-2x"></i>
        </div>

        <div *ngIf="!loading" class="table-responsive">
          <table class="table table-borderless table-hover return-settings-table mb-0">
            <thead>
              <tr>
                <th class="th-id">#</th>
                <th class="th-status text-center">Stato</th>
                <th>Cliente</th>
                <th>Brand</th>
                <th>Tipo</th>
                <th>Nome</th>
                <th>Pallet</th>
                <th class="text-center">Azioni</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredItems(); let i = index">
                <td class="td-id">{{ i + 1 }}</td>
                <td class="td-status text-center">
                  <span class="status-dot"
                        [class.status-dot-active]="(item.returnStatus || 'ACTIVE') === 'ACTIVE'"
                        [class.status-dot-inactive]="(item.returnStatus || 'ACTIVE') !== 'ACTIVE'"
                        [title]="(item.returnStatus || 'ACTIVE') === 'ACTIVE' ? 'Attivo' : 'Inattivo'"></span>
                </td>
                <td>{{ getClientName(item.returnClientCode) }}</td>
                <td>{{ getBrandName(item.returnClientCode, item.returnBrandCode) }}</td>
                <td>{{ item.returnType || '-' }}</td>
                <td>{{ item.returnName || '-' }}</td>
                <td>{{ item.returnPalletName || '-' }}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-link p-0 text-primary action-btn" (click)="selectForEdit(item)" title="Modifica">
                    <i class="fas fa-edit"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredItems().length === 0">
                <td colspan="8" class="text-center text-muted py-3">
                  <i class="fas fa-inbox me-2"></i> Nessun record
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ===== TAB: NUOVO / MODIFICA (form condiviso) ===== -->
      <div class="tab-content" *ngIf="activeTab === 'new' || activeTab === 'edit'">
        <form id="return-settings-form" (ngSubmit)="activeTab === 'new' ? insert() : update()" #f="ngForm">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Cliente <span class="text-danger">*</span></label>
              <div class="input-icon-wrapper">
                <select class="form-select"
                        name="returnClientCode"
                        [(ngModel)]="formModel.returnClientCode"
                        #returnClientCode="ngModel"
                        required
                        (ngModelChange)="onClientChange()"
                        [class.is-invalid]="returnClientCode.invalid && (returnClientCode.touched || f.submitted)">
                  <option value="">{{ loadingClients ? 'Caricamento...' : '-- Seleziona cliente --' }}</option>
                  <option *ngFor="let c of clients" [value]="c.clientCode">
                    {{ c.clientName || c.clientCode }}<span *ngIf="c.clientAcronym"> ({{ c.clientAcronym }})</span>
                  </option>
                </select>
                <i class="input-icon fas fa-user-tag"></i>
              </div>
              <div class="invalid-feedback">Cliente obbligatorio</div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Brand <span class="text-danger">*</span></label>
              <div class="input-icon-wrapper">
                <select class="form-select"
                        name="returnBrandCode"
                        [(ngModel)]="formModel.returnBrandCode"
                        #returnBrandCode="ngModel"
                        required
                        [disabled]="!formModel.returnClientCode"
                        [class.is-invalid]="returnBrandCode.invalid && (returnBrandCode.touched || f.submitted)">
                  <option value="">
                    {{ !formModel.returnClientCode ? 'Seleziona prima un cliente' : '-- Seleziona brand --' }}
                  </option>
                  <option *ngFor="let b of brandsForSelectedClient()" [value]="b.brandCode">
                    {{ b.brandAcronym || b.brandName || b.brandCode }}<span *ngIf="b.brandName && b.brandAcronym"> — {{ b.brandName }}</span>
                  </option>
                </select>
                <i class="input-icon fas fa-tag"></i>
              </div>
              <div class="invalid-feedback">Brand obbligatorio</div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Tipo Reso <span class="text-danger">*</span></label>
              <div class="input-icon-wrapper">
                <input type="text" class="form-control"
                       name="returnType"
                       [(ngModel)]="formModel.returnType"
                       #returnType="ngModel"
                       required
                       maxlength="50"
                       placeholder="Es. STANDARD, URGENTE..."
                       [class.is-invalid]="returnType.invalid && (returnType.touched || f.submitted)">
                <i class="input-icon fas fa-undo-alt"></i>
              </div>
              <div class="invalid-feedback">Tipo reso obbligatorio</div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Nome <span class="text-danger">*</span></label>
              <div class="input-icon-wrapper">
                <input type="text" class="form-control"
                       name="returnName"
                       [(ngModel)]="formModel.returnName"
                       #returnName="ngModel"
                       required
                       maxlength="100"
                       placeholder="Nome identificativo del reso"
                       [class.is-invalid]="returnName.invalid && (returnName.touched || f.submitted)">
                <i class="input-icon fas fa-signature"></i>
              </div>
              <div class="invalid-feedback">Nome obbligatorio</div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Tipo Pallet <span class="text-danger">*</span></label>
              <div class="input-icon-wrapper">
                <input type="text" class="form-control"
                       name="returnPalletType"
                       [(ngModel)]="formModel.returnPalletType"
                       #returnPalletType="ngModel"
                       required
                       maxlength="50"
                       placeholder="Es. EUR, INDUSTRIALE..."
                       [class.is-invalid]="returnPalletType.invalid && (returnPalletType.touched || f.submitted)">
                <i class="input-icon fas fa-layer-group"></i>
              </div>
              <div class="invalid-feedback">Tipo pallet obbligatorio</div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Nome Pallet <span class="text-danger">*</span></label>
              <div class="input-icon-wrapper">
                <input type="text" class="form-control"
                       name="returnPalletName"
                       [(ngModel)]="formModel.returnPalletName"
                       #returnPalletName="ngModel"
                       required
                       maxlength="100"
                       placeholder="Nome descrittivo del pallet"
                       [class.is-invalid]="returnPalletName.invalid && (returnPalletName.touched || f.submitted)">
                <i class="input-icon fas fa-pallet"></i>
              </div>
              <div class="invalid-feedback">Nome pallet obbligatorio</div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Lunghezza (cm)</label>
              <div class="input-icon-wrapper">
                <input type="number" step="0.01" min="0" class="form-control"
                       name="returnPalletLength"
                       [(ngModel)]="formModel.returnPalletLength"
                       #returnPalletLength="ngModel"
                       placeholder="0.00"
                       [class.is-invalid]="returnPalletLength.invalid && (returnPalletLength.touched || f.submitted)">
                <i class="input-icon fas fa-ruler-horizontal"></i>
              </div>
              <div class="invalid-feedback">Valore non valido</div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Larghezza (cm)</label>
              <div class="input-icon-wrapper">
                <input type="number" step="0.01" min="0" class="form-control"
                       name="returnPalletWidth"
                       [(ngModel)]="formModel.returnPalletWidth"
                       #returnPalletWidth="ngModel"
                       placeholder="0.00"
                       [class.is-invalid]="returnPalletWidth.invalid && (returnPalletWidth.touched || f.submitted)">
                <i class="input-icon fas fa-ruler"></i>
              </div>
              <div class="invalid-feedback">Valore non valido</div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Altezza (cm)</label>
              <div class="input-icon-wrapper">
                <input type="number" step="0.01" min="0" class="form-control"
                       name="returnPalletHeight"
                       [(ngModel)]="formModel.returnPalletHeight"
                       #returnPalletHeight="ngModel"
                       placeholder="0.00"
                       [class.is-invalid]="returnPalletHeight.invalid && (returnPalletHeight.touched || f.submitted)">
                <i class="input-icon fas fa-ruler-vertical"></i>
              </div>
              <div class="invalid-feedback">Valore non valido</div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Peso (kg)</label>
              <div class="input-icon-wrapper">
                <input type="number" step="0.01" min="0" class="form-control"
                       name="returnPalletWeight"
                       [(ngModel)]="formModel.returnPalletWeight"
                       #returnPalletWeight="ngModel"
                       placeholder="0.00"
                       [class.is-invalid]="returnPalletWeight.invalid && (returnPalletWeight.touched || f.submitted)">
                <i class="input-icon fas fa-weight-hanging"></i>
              </div>
              <div class="invalid-feedback">Valore non valido</div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Volume (m³)</label>
              <div class="input-icon-wrapper">
                <input type="number" step="0.01" min="0" class="form-control"
                       name="returnPalletVolume"
                       [(ngModel)]="formModel.returnPalletVolume"
                       #returnPalletVolume="ngModel"
                       placeholder="0.00"
                       [class.is-invalid]="returnPalletVolume.invalid && (returnPalletVolume.touched || f.submitted)">
                <i class="input-icon fas fa-cube"></i>
              </div>
              <div class="invalid-feedback">Valore non valido</div>
            </div>

            <!-- Toggle stato (solo in modifica) — affiancato al Volume -->
            <div class="col-md-3" *ngIf="activeTab === 'edit'">
              <label class="form-label d-block">Stato</label>
              <div class="status-toggle btn-group w-100" role="group" aria-label="Stato del reso">
                <input type="radio" class="btn-check" id="statusActive"
                       name="returnStatus" value="ACTIVE"
                       [(ngModel)]="formModel.returnStatus">
                <label class="btn btn-outline-success" for="statusActive">
                  <i class="fas fa-check-circle me-1"></i> ACTIVE
                </label>

                <input type="radio" class="btn-check" id="statusInactive"
                       name="returnStatus" value="INACTIVE"
                       [(ngModel)]="formModel.returnStatus">
                <label class="btn btn-outline-secondary" for="statusInactive">
                  <i class="fas fa-ban me-1"></i> INACTIVE
                </label>
              </div>
            </div>

            <div class="col-12">
              <label class="form-label">Descrizione</label>
              <div class="input-icon-wrapper">
                <textarea class="form-control" rows="2"
                          name="returnDescription"
                          [(ngModel)]="formModel.returnDescription"
                          maxlength="500"
                          placeholder="Eventuale descrizione del tipo di reso..."></textarea>
                <i class="input-icon input-icon-top fas fa-align-left"></i>
              </div>
            </div>

          </div>

          <!-- Riepilogo errori -->
          <div *ngIf="f.submitted && f.invalid" class="alert alert-warning mt-3 mb-0 py-2">
            <i class="fas fa-exclamation-triangle me-2"></i>
            Compila tutti i campi obbligatori contrassegnati con <span class="text-danger">*</span>
          </div>
        </form>
      </div>

    </div>

    <!-- ===== FOOTER ===== -->
    <div class="popup-footer">
      <div class="d-flex justify-content-between align-items-center">
        <div class="text-muted small">
          <span *ngIf="activeTab === 'list'">{{ filteredItems().length }} record</span>
          <span *ngIf="activeTab === 'edit' && selected">In modifica: <strong>#{{ selected.returnId }}</strong></span>
          <span *ngIf="activeTab === 'new'">Nuovo record</span>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-outline-secondary" (click)="close()">
            <i class="fas fa-times me-1"></i> Chiudi
          </button>

          <ng-container *ngIf="activeTab === 'list'">
            <button type="button" class="btn btn-outline-secondary" (click)="loadAll()" [disabled]="loading">
              <i class="fas" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-sync'"></i>
              <span class="ms-1">Aggiorna</span>
            </button>
            <button type="button" class="btn btn-primary" (click)="setActiveTab('new')">
              <i class="fas fa-plus me-1"></i> Nuovo
            </button>
          </ng-container>

          <ng-container *ngIf="activeTab === 'new' || activeTab === 'edit'">
            <button type="submit" form="return-settings-form" class="btn btn-primary" [disabled]="saving">
              <i class="fas" [ngClass]="saving ? 'fa-spinner fa-spin' : (activeTab === 'new' ? 'fa-plus' : 'fa-save')"></i>
              <span class="ms-1">{{ activeTab === 'new' ? 'Crea' : 'Salva modifiche' }}</span>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
